module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-22.f2d346a0.jpg";